
export default {
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    dispayName: {
      type: String,
      required: true,
    },
    additionalText: {
      type: String,
      required: false,
      default: undefined,
    },
    details: {
      type: Array,
      required: true,
    },
  },
}
